module.exports = __webpack_public_path__ + "assets/images/circle-of-pie-chart-for-business_esmerald.svg?ae36154a5a3247de51467426a8024431";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/circle-of-pie-chart-for-business_esmerald.svg
// module id = 613
// module chunks = 0